import PropTypes from "prop-types";
import { useTheme } from "styled-components";

import { ComposedChart, ChartTooltip } from "components/Chart";
import { NoDataMessage } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { DrawdownPlaceholder } from "./DrawdownPlaceholder";

// const convertToData = (value) => {
//   return convertTimestampToDate(value, "", MONTH_DATE_YEAR_FORMAT);
// };

const convertValue = (value) => (value ? `${value}%` : value);

const DrawdownChart = ({ data, height, isLoading }) => {
  const theme = useTheme();
  // const [activePeriod, setActivePeriod] = useState("1d");

  // const handleFilterClick = (id) => {
  //   setActivePeriod(id);
  // };

  let chart = data.map((chartData) => {
    const color = theme.chart.bar.primary;
    chartData.color = color;
    return chartData;
  });

  if (isLoading) {
    return <DrawdownPlaceholder height={height} />;
  }

  return (
    <div>
      {data.length ? (
        <div style={{ width: "100%", height }}>
          <ComposedChart
            data={chart}
            // xAxisProps={{
            //   dataKey: "name",
            //   fontSize: 12,
            //   stroke: theme.chart.axis.primary,
            //   tickFormatter: convertToData,
            // }}
            yAxisProps={{
              fontSize: 12,
              stroke: theme.chart.axis.primary,
              domain: ["auto", 0],
              tickFormatter: convertValue,
            }}
            composedChartProps={{
              margin: { right: 20, left: 5 },
              barSize: 70,
            }}
            // cartesianGridProps={{
            //   opacity: 0.3,
            //   vertical: false,
            // }}
            tooltipContent={ChartTooltip}
          />
        </div>
      ) : (
        <NoDataMessage>No data to display</NoDataMessage>
      )}

      {/* {data.length > 0 && (
        <Filter
          className="mt-2"
          activePeriod={activePeriod}
          handleFilterClick={handleFilterClick}
        />
      )} */}
    </div>
  );
};

DrawdownChart.propTypes = {
  data: PropTypes.array,
  height: PropTypes.string,
  isLoading: PropTypes.bool,
};

DrawdownChart.defaultProps = {
  data: [],
  height: "250px",
};

export { DrawdownChart };
